import classnames from "classnames";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";

import Icon from "../../Icon";
import { FormControl } from "../Form";
import FormHelper from "../FormHelper";
import FormInput from "../FormInput";
import Label from "../Label";

import { isValidEmail } from "../../../helpers";

import "../TextInput/textInput.scss";

const EmailInput = ({
  name,
  label,
  options,
  autoComplete,
  className,
  parentClassName,
  isMulti,
}) => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();
  const currentValue = useWatch({
    control,
    name,
  });
  const [isFocused, setIsFocused] = useState(false);

  const currentError = errors[name];
  const hasValue = typeof currentValue !== "undefined" && currentValue !== "";
  isMulti = typeof isMulti !== "undefined" && isMulti !== false;

  const validateInput = (input) => {
    if (!input) return true;
    if (isMulti) {
      let isError = true;

      input.split(",").forEach((item) => {
        isError = isError && isValidEmail(item);
      });
      return isError;
    }

    return isValidEmail(input);
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = (e) => {
    setIsFocused(false);
  };

  return (
    <FormControl className={parentClassName}>
      <FormInput
        type="text"
        className={classnames(className, {
          "has-value": hasValue,
          "has-error": currentError,
          "is-active": isFocused,
          "is-disabled": options?.disabled,
        })}
      >
        <Label
          htmlFor={name}
          text={label}
          required={options?.required}
          showRequiredAsterisk={options?.showAsterisk}
          showRequiredLabel={true}
        />
        <input
          id={name}
          className={classnames({ [`text-input--${name}`]: name })}
          type="email"
          autoComplete={autoComplete}
          disabled={options?.disabled}
          readOnly={options?.readOnly}
          aria-invalid={!!currentError}
          aria-autocomplete="both"
          aria-haspopup="false"
          autoCapitalize="false"
          placeholder={options?.placeholder}
          onFocus={handleFocus}
          {...register(name, {
            ...options,
            onBlur: handleBlur,
            validate: (e) => validateInput(e) || "Invalid Email Address",
          })}
        />

        {hasValue && (
          <div className="form-validation-icons">
            {validateInput(currentValue) && (
              <Icon name="system-checkmark" theme="success" />
            )}
            {currentError && <Icon name="system-warning" theme="error" />}
          </div>
        )}
      </FormInput>

      {currentError && <FormHelper error={currentError} label={label} />}
    </FormControl>
  );
};

EmailInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.object,
  autoComplete: PropTypes.string,
  className: PropTypes.string,
  parentClassName: PropTypes.string,
};

EmailInput.defaultProps = {
  options: {},
  autoComplete: "off",
  parentClassName: "",
};

export default EmailInput;
